import { render, staticRenderFns } from "./customer-detail.vue?vue&type=template&id=549f1dec&scoped=true&"
import script from "./customer-detail.vue?vue&type=script&lang=js&"
export * from "./customer-detail.vue?vue&type=script&lang=js&"
import style0 from "./customer-detail.vue?vue&type=style&index=0&id=549f1dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f1dec",
  null
  
)

export default component.exports